import React, { useEffect, useRef } from "react";
import { track } from "../utils/analytics";

// Deliberately shown to everyone rather than sniffing for macOS: the SPA has no
// platform detection anywhere today, iPadOS reports Mac-ish strings, and the
// copy works as "here's what else exists" for people who can't use it yet.
const HREF =
  "https://muraja.app/mac/?utm_source=web_app&utm_medium=referral" +
  "&utm_campaign=mac_app&utm_content=irab_public";

/**
 * Promo strip under the public iʿrāb panel, pointing at the Mac app.
 *
 * Styled on IrabUpsell — the same inline-offer shape. Note the colours come
 * from inline `style` with pre-baked alpha variables, not Tailwind slash
 * opacity: the `dt-*` tokens are `var()`-backed, so `bg-dt-gold/12` silently
 * produces nothing.
 */
export default function MacAppCta() {
  const seen = useRef(false);

  useEffect(() => {
    // StrictMode double-invokes effects in development; only count the view once.
    if (seen.current) return;
    seen.current = true;
    track("mac-cta-view", { context: "irab-public" });
  }, []);

  return (
    <section className="w-full max-w-3xl mx-auto px-3 sm:px-4 pb-8">
      <div
        className="px-4 py-3.5 rounded-xl flex flex-col sm:flex-row sm:items-center gap-3"
        style={{ background: "var(--gold-bg)", border: "1px solid var(--panel-line)" }}
      >
        <div className="flex-1">
          <p className="text-sm font-semibold text-dt-parchment">
            Iʿrāb also works outside the browser
          </p>
          <p className="text-xs text-dt-parchment-dim mt-0.5">
            Muraja Iʿrāb is a menu bar app for macOS. Select Arabic in any app — a PDF, a
            book, subtitles — press ⌥⌘E, and the same analysis appears beside it. It reads
            scanned pages too.
          </p>
        </div>
        <a
          href={HREF}
          onClick={() => track("mac-cta-click", { context: "irab-public" })}
          className="shrink-0 px-4 py-2 rounded-xl bg-dt-gold text-dt-ink hover:brightness-105 text-sm font-semibold transition-[filter] no-underline text-center"
        >
          See the Mac app
        </a>
      </div>
    </section>
  );
}
